import {useEffect, useState} from "react";
import style from "../inputText/Input.module.css";
import styleAutocomplete from "./Autocomplete.module.css"
import {useDispatch} from "react-redux";
import {setRender} from "../../actions/IndexActions";

function Autocomplete(props) {

    const [value, setValue] = useState(props.value)
    const dispatch = useDispatch()
    useEffect(() => {
        autocomplete(document.getElementById(props.id), props.suggestions);
        dispatch(setRender())
    }, [])

    useEffect(() => {
        autocomplete(document.getElementById(props.id), props.suggestions);
        dispatch(setRender())
    }, [props.rerender])

    function onChangeInput(v) {
        setValue(v)
        if(v === ""){
            props.onChange(props.id,v,props.index,props.nomeOggetto)
        }
    }

    function autocomplete(inp, arr) {
        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        let currentFocus;
        if (props.value && props.value.descrizione) {
            inp.value = props.value.descrizione;
        } else {
            inp.value = ""
        }
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function (e) {
            let a, b, i, val = this.value;
            /*close any already open lists of autocompleted values*/
            closeAllLists();
            if (!val) {
                return false;
            }
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            let suggestions = false

            a = document.createElement("DIV");
            a.setAttribute("id", this.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items ".concat(styleAutocomplete.suggestions));
            if(props.style){
                let customStyle = {...props.style}
                let customStyleString = JSON.stringify(customStyle).replaceAll("\"","").replace("{","").replace("}","")
                a.setAttribute("style",customStyleString );
            }
            if (this.parentNode.childNodes[1]) {
                this.parentNode.replaceChild(a, this.parentNode.childNodes[1])
            } else {
                this.parentNode.appendChild(a)
            }
            /*append the DIV element as a child of the autocomplete container:*/
            /*for each item in the array...*/
            for (i = 0; i < arr.length; i++) {
                /*check if the item starts with the same letters as the text field value:*/
                if (arr[i].descrizione.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                    suggestions = true
                    /*create a DIV element for each matching element:*/
                    b = document.createElement("DIV");
                    b.setAttribute("class", styleAutocomplete.suggestion)
                    b.setAttribute("id", i)
                    b.innerHTML = arr[i].descrizione;
                    /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("mousedown", function (e) {
                        /*insert the value for the autocomplete text field:*/
                        inp.value = arr[parseInt(e.currentTarget.id)].descrizione;
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        props.onChange(props.id, arr[parseInt(e.currentTarget.id)],props.index,props.nomeOggetto)
                        onChangeInput(arr[parseInt(e.currentTarget.id)])
                        closeAllLists();
                    });
                    b.addEventListener("mouseover", function (e) {
                        currentFocus = parseInt(e.currentTarget.id)
                        addActive(a.getElementsByTagName("div"), true);
                    })
                    a.appendChild(b);
                }
            }
            if (!suggestions) {
                let span = document.createElement("SPAN")
                span.setAttribute("class", styleAutocomplete.noSuggestions)
                span.innerHTML = "Nessun Suggerimento Disponibile"
                if (this.parentNode.childNodes[1]) {
                    this.parentNode.replaceChild(span, this.parentNode.childNodes[1])
                } else {
                    this.parentNode.appendChild(span)
                }
            }
        });
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function (e) {
            let x = document.getElementById(this.id + "autocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode === 40) {
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x, true);
            } else if (e.keyCode === 38) { //up
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x, true);
            } else if (e.keyCode === 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.preventDefault();
                if (currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (x) x[currentFocus].click();
                    /*insert the value for the autocomplete text field:*/
                    if(x && x[currentFocus]){
                        inp.value = arr[parseInt(x[currentFocus].id)].descrizione;
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        props.onChange(props.id, arr[parseInt(x[currentFocus].id)],props.index,props.nomeOggetto)
                        onChangeInput(arr[parseInt(x[currentFocus].id)])
                        closeAllLists();
                    }

                }
            }
        });

        function addActive(x, flagRemove) {
            /*a function to classify an item as "active":*/
            if (!x) return false;
            /*start by removing the "active" class on all items:*/
            if (flagRemove) removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            /*add class "autocomplete-active":*/
            x[currentFocus].classList.add(styleAutocomplete.suggestionSelected);
        }

        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (let i = 0; i < x.length; i++) {
                x[i].classList.remove(styleAutocomplete.suggestionSelected);
            }
        }

        function closeAllLists(elmnt) {
            /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
            let x = document.getElementsByClassName("autocomplete-items");
            for (let i = 0; i < x.length; i++) {
                if (elmnt !== x[i] && elmnt !== inp) {
                    x[i].parentNode.removeChild(x[i]);
                }
            }
        }

        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }

    function onBlurInput() {
        let inp = document.getElementById(props.id)
        let div = document.getElementById("div" + props.id)
        if (value && inp.value === value && !value.codice) {
            inp.value = "";
            setValue("")
            props.onChange(props.id, "",props.index,props.nomeOggetto)
            let s = inp.nextElementSibling
            if(s instanceof HTMLElement){
                div.removeChild(s)
            }
        }
    }

    return (
        <div id={"div" + props.id} onBlur={onBlurInput}>
            {/* aria-label fornisce il nome accessibile del campo (WCAG 1.3.1 / 3.3.2):
                il componente non genera <label> e l'etichetta visibile e' uno <span>
                adiacente. Attributo ARIA: nessun impatto sulla resa grafica. */}
            <input className={style.txtInput} id={props.id} type="text"
                   aria-label={props.ariaLabel}
                   placeholder={props.placeholder} autoComplete={"off"} disabled={props.disabled}
                   onChange={(event) => onChangeInput(event.target.value)}
                   style={props.style}
            />
        </div>

    );

}

export default Autocomplete
